/* Lumynest — bundle rows, swatches, gallery, lightbox, cart. */
(function () {
  var root = document.querySelector('[data-lmp-root]');
  if (!root) return;

  function readJSON(sel) {
    var el = document.querySelector(sel);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  var variants    = readJSON('[data-lmp-variants]') || [];
  var optionNames = readJSON('[data-lmp-options]') || [];
  var swatchHex   = readJSON('[data-lmp-swatches]') || {};

  var bundle    = root.querySelector('[data-lmp-bundle]');
  var priceEl   = root.querySelector('[data-lmp-price]');
  var addBtn    = root.querySelector('[data-lmp-add]');
  var tiers     = root.querySelectorAll('[data-lmp-tier]');
  var picksWrap = root.querySelector('[data-lmp-picks]');
  var picksRows = root.querySelector('[data-lmp-picks-rows]');
  var savings   = root.querySelector('[data-lmp-savings]');
  var footBox   = root.querySelector('[data-lmp-foot]');
  var stickyPr  = document.querySelector('[data-lmp-sticky-price]');

  var imgs   = root.querySelectorAll('[data-lmp-img]');
  var thumbs = root.querySelectorAll('[data-lmp-thumb]');

  var moneyTpl = root.getAttribute('data-money') || '$0.00';
  var unit = parseInt(root.getAttribute('data-base-price'), 10) || 0;
  var fallbackImg = bundle ? (bundle.getAttribute('data-fallback-img') || '') : '';
  var addLabel = addBtn ? addBtn.textContent.trim() : 'Add to cart';
  var productTitle = ((document.querySelector('.lmp__title') || {}).textContent || '').trim();
  var current = 0;

  function money(c) { return moneyTpl.replace(/[0-9][0-9.,]*/, (c / 100).toFixed(2)); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) {
      return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[m];
    });
  }
  function titleCase(s) {
    return String(s || '').replace(/\S+/g, function (w) {
      return w.charAt(0).toUpperCase() + w.slice(1);
    });
  }

  var colourIdx = -1;
  optionNames.forEach(function (n, i) {
    var s = String(n).toLowerCase();
    if (colourIdx === -1 && (s.indexOf('colour') > -1 || s.indexOf('color') > -1)) colourIdx = i;
  });

  function optionValues(idx) {
    var seen = [];
    variants.forEach(function (vv) {
      var val = vv['option' + (idx + 1)];
      if (val && seen.indexOf(val) === -1) seen.push(val);
    });
    return seen;
  }

  function variantImageFor(idx, value) {
    var hit = null;
    variants.forEach(function (vv) {
      if (hit) return;
      if (vv['option' + (idx + 1)] !== value) return;
      var m = vv.featured_image || vv.featured_media;
      if (m) hit = m.src || (m.preview_image && m.preview_image.src) || null;
    });
    return hit;
  }

  /* ---------- gallery ---------- */
  function showMedia(idx) {
    if (idx === null || idx === undefined || isNaN(idx) || idx < 0) return;
    var key = String(idx), found = false;
    imgs.forEach(function (im) { if (im.getAttribute('data-lmp-img') === key) found = true; });
    if (!found) return;
    current = parseInt(key, 10);
    imgs.forEach(function (im) { im.classList.toggle('is-active', im.getAttribute('data-lmp-img') === key); });
    thumbs.forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-lmp-thumb') === key); });
    var active = root.querySelector('[data-lmp-thumb].is-active');
    if (active && active.scrollIntoView) active.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
  }

  function mediaIndexFor(variant) {
    if (!variant) return null;
    if (variant.featured_media && typeof variant.featured_media.position === 'number') return variant.featured_media.position - 1;
    if (variant.featured_image && typeof variant.featured_image.position === 'number') return variant.featured_image.position - 1;
    return null;
  }

  thumbs.forEach(function (th) {
    th.addEventListener('click', function () { showMedia(parseInt(th.getAttribute('data-lmp-thumb'), 10)); });
  });

  /* ---------- lightbox ---------- */
  var lb = document.querySelector('[data-lmp-lb]');
  var lbImg = document.querySelector('[data-lmp-lb-img]');
  var lbCount = document.querySelector('[data-lmp-lb-count]');
  var lbIndex = 0;

  function lbSrc(i) {
    var el = root.querySelector('[data-lmp-img="' + i + '"]');
    return el ? (el.getAttribute('data-full') || el.getAttribute('src')) : '';
  }
  function lbShow(i) {
    if (!lb || !imgs.length) return;
    lbIndex = (i + imgs.length) % imgs.length;
    lbImg.src = lbSrc(lbIndex);
    if (lbCount) lbCount.textContent = (lbIndex + 1) + ' / ' + imgs.length;
  }
  function lbOpen() {
    if (!lb || !imgs.length) return;
    lbShow(current); lb.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
  }
  function lbClose() {
    if (!lb) return;
    lb.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    showMedia(lbIndex);
  }

  var opener = root.querySelector('[data-lmp-open-lb]');
  if (opener) opener.addEventListener('click', lbOpen);

  if (lb) {
    var lbC = lb.querySelector('[data-lmp-lb-close]');
    var lbP = lb.querySelector('[data-lmp-lb-prev]');
    var lbN = lb.querySelector('[data-lmp-lb-next]');
    if (lbC) lbC.addEventListener('click', lbClose);
    if (lbP) lbP.addEventListener('click', function () { lbShow(lbIndex - 1); });
    if (lbN) lbN.addEventListener('click', function () { lbShow(lbIndex + 1); });
    lb.addEventListener('click', function (e) {
      if (e.target === lb || e.target.classList.contains('lmp-lb__stage')) lbClose();
    });
    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') lbClose();
      if (e.key === 'ArrowLeft') lbShow(lbIndex - 1);
      if (e.key === 'ArrowRight') lbShow(lbIndex + 1);
    });
    var tx = 0;
    lb.addEventListener('touchstart', function (e) { tx = e.changedTouches[0].clientX; }, { passive: true });
    lb.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - tx;
      if (Math.abs(dx) > 45) lbShow(lbIndex + (dx < 0 ? 1 : -1));
    }, { passive: true });
  }

  /* ---------- primary selection ---------- */
  var primary = {};
  root.querySelectorAll('[data-lmp-oi].is-on').forEach(function (b) {
    primary[b.getAttribute('data-lmp-oi')] = b.getAttribute('data-lmp-ov');
  });

  function findVariant(sel) {
    return variants.find(function (vv) {
      return Object.keys(sel).every(function (i) { return vv['option' + (parseInt(i, 10) + 1)] === sel[i]; });
    });
  }

  function currentTier() {
    var a = root.querySelector('[data-lmp-tier].is-active');
    return {
      qty: a ? (parseInt(a.getAttribute('data-qty'), 10) || 1) : 1,
      disc: a ? (parseInt(a.getAttribute('data-disc'), 10) || 0) : 0
    };
  }

  /* ---------- bundle rows ---------- */
  var rowState = [];

  function defaultSelection() {
    var s = {};
    Object.keys(primary).forEach(function (k) { s[k] = primary[k]; });
    return s;
  }

  function rowVariant(sel) {
    if (!sel || Object.keys(sel).length < optionNames.length) return null;
    return findVariant(sel);
  }

  function rowThumb(sel) {
    if (colourIdx > -1 && sel[colourIdx]) {
      var vi = variantImageFor(colourIdx, sel[colourIdx]);
      if (vi) return vi + '&width=180';
    }
    return fallbackImg;
  }

  function renderRow(n) {
    var sel = rowState[n] || (rowState[n] = defaultSelection());
    var m = rowVariant(sel);
    var t = currentTier();
    var was = unit;
    var now = was - Math.round(was * t.disc / 100);

    var meta = optionNames.map(function (name, i) {
      return esc(name) + ': ' + esc(titleCase(sel[i]) || '\u2014');
    }).join('<br>');

    var warn = '';
    if (Object.keys(sel).length === optionNames.length) {
      if (!m) warn = '<p class="lmb-row__warn">That combination is not available</p>';
      else if (!m.available) warn = '<p class="lmb-row__warn">Out of stock \u2014 pick another</p>';
    }

    var priceHtml = t.disc > 0 ? '<s>' + money(was) + '</s>' + money(now) : money(now);

    var editsHtml = optionNames.map(function (name, i) {
      var vals = optionValues(i);
      var label = '<span class="lmb-row__label">' + esc(name) + '</span>';
      if (i === colourIdx) {
        return '<div class="lmb-row__field">' + label +
          '<div class="lmb-sw">' + vals.map(function (val) {
            var hex = swatchHex[val] || '#D8D4CC';
            return '<button type="button" class="lmb-sw__btn' + (sel[i] === val ? ' is-on' : '') + '"' +
              ' style="background-color:' + hex + '" title="' + esc(titleCase(val)) + '" aria-label="' + esc(titleCase(val)) + '"' +
              ' data-row-opt="' + i + '" data-row-val="' + esc(val) + '"></button>';
          }).join('') + '</div></div>';
      }
      return '<div class="lmb-row__field">' + label +
        '<div class="lmb-sz">' + vals.map(function (val) {
          return '<button type="button" class="lmb-sz__btn' + (sel[i] === val ? ' is-on' : '') + '"' +
            ' data-row-opt="' + i + '" data-row-val="' + esc(val) + '">' + esc(val) + '</button>';
        }).join('') + '</div></div>';
    }).join('');

    return '<div class="lmb-row" data-row="' + n + '">' +
      '<span class="lmb-row__img"><img src="' + rowThumb(sel) + '" alt="" loading="lazy"></span>' +
      '<div class="lmb-row__body">' +
        '<div class="lmb-row__top">' +
          '<span class="lmb-row__name">' + esc(productTitle) + '</span>' +
          '<button type="button" class="lmb-row__edit" data-row-edit>Customise</button>' +
        '</div>' +
        '<p class="lmb-row__meta">' + meta + '</p>' +
        '<p class="lmb-row__price">' + priceHtml + '</p>' + warn +
        '<div class="lmb-row__edits">' + editsHtml + '</div>' +
      '</div>' +
    '</div>';
  }

  function renderSavings() {
    var t = currentTier();
    var was = unit * t.qty;
    var now = was - Math.round(was * t.disc / 100);
    var show = t.disc > 0 && t.qty > 1;

    function fill(box, wSel, nSel, pSel) {
      if (!box) return;
      if (!show) { box.hidden = true; return; }
      box.hidden = false;
      var w = box.querySelector(wSel), nn = box.querySelector(nSel), p = box.querySelector(pSel);
      if (w) w.textContent = money(was);
      if (nn) nn.textContent = money(now);
      if (p) p.textContent = t.disc + '% off';
    }
    fill(savings, '[data-savings-was]', '[data-savings-now]', '[data-savings-pct]');
    fill(footBox, '[data-foot-was]', '[data-foot-now]', '[data-foot-pct]');
  }

  function buildRows() {
    if (!picksWrap || !picksRows) return;
    var qty = currentTier().qty;
    if (qty < 2) {
      picksWrap.classList.remove('is-on');
      picksRows.innerHTML = '';
      rowState = [];
      renderSavings();
      return;
    }
    picksWrap.classList.add('is-on');
    rowState.length = qty;
    var html = '';
    for (var n = 0; n < qty; n++) html += renderRow(n);
    picksRows.innerHTML = html;
    renderSavings();
  }

  function refreshRow(n) {
    var el = picksRows.querySelector('[data-row="' + n + '"]');
    if (!el) return;
    var wasOpen = el.classList.contains('is-editing');
    el.outerHTML = renderRow(n);
    if (wasOpen) {
      var fresh = picksRows.querySelector('[data-row="' + n + '"]');
      if (fresh) fresh.classList.add('is-editing');
    }
  }

  if (picksRows) {
    picksRows.addEventListener('click', function (e) {
      var edit = e.target.closest('[data-row-edit]');
      if (edit) {
        var r = edit.closest('.lmb-row');
        if (r) r.classList.toggle('is-editing');
        return;
      }
      var opt = e.target.closest('[data-row-opt]');
      if (!opt) return;
      var row = opt.closest('.lmb-row');
      if (!row) return;
      var n = parseInt(row.getAttribute('data-row'), 10);
      rowState[n] = rowState[n] || defaultSelection();
      rowState[n][opt.getAttribute('data-row-opt')] = opt.getAttribute('data-row-val');
      refreshRow(n);
      updateAddState();
    });
  }

  /* ---------- cart ----------
     Every bundle line comes from rowState, including the first.
     Row 0 is seeded from the main picker, so a change there is respected. */
  function collectItems() {
    var t = currentTier();

    if (t.qty < 2) {
      var pv = findVariant(primary);
      if (!pv || !pv.available) return null;
      return [{ id: pv.id, quantity: 1 }];
    }

    var merged = {};
    for (var n = 0; n < t.qty; n++) {
      var m = rowVariant(rowState[n]);
      if (!m || !m.available) return null;
      merged[m.id] = (merged[m.id] || 0) + 1;
    }
    return Object.keys(merged).map(function (id) {
      return { id: parseInt(id, 10), quantity: merged[id] };
    });
  }

  function updateAddState() {
    if (!addBtn) return;
    var pv = findVariant(primary);
    if (!pv || !pv.available) { addBtn.disabled = true; addBtn.textContent = 'Sold out'; return; }
    var t = currentTier();
    var items = collectItems();
    if (t.qty > 1 && !items) { addBtn.disabled = true; addBtn.textContent = 'Choose your ' + t.qty + ' items'; return; }
    addBtn.disabled = false;
    addBtn.textContent = t.qty > 1 ? ('Add ' + t.qty + ' to cart') : addLabel;
  }

  function repriceTiers() {
    tiers.forEach(function (t) {
      var q = parseInt(t.getAttribute('data-qty'), 10) || 1;
      var d = parseInt(t.getAttribute('data-disc'), 10) || 0;
      var full = unit * q;
      var now = full - Math.round(full * d / 100);
      var nowEl = t.querySelector('[data-tier-now]');
      var wasEl = t.querySelector('[data-tier-was]');
      var eachEl = t.querySelector('[data-tier-each]');
      if (nowEl) nowEl.textContent = money(now);
      if (wasEl) wasEl.textContent = money(full);
      if (eachEl) eachEl.textContent = money(Math.round(now / q)) + ' each';
    });
  }

  function syncPrimary() {
    var m = findVariant(primary);
    if (!m) { updateAddState(); return; }
    unit = m.price;
    if (priceEl) priceEl.textContent = money(m.price);
    if (stickyPr) stickyPr.textContent = money(m.price);
    showMedia(mediaIndexFor(m));
    repriceTiers();
    buildRows();
    updateAddState();
  }

  tiers.forEach(function (t) {
    t.addEventListener('click', function () {
      tiers.forEach(function (x) { x.classList.remove('is-active'); });
      t.classList.add('is-active');
      buildRows(); updateAddState();
    });
  });

  root.querySelectorAll('[data-lmp-oi]').forEach(function (b) {
    b.addEventListener('click', function () {
      var i = b.getAttribute('data-lmp-oi');
      root.querySelectorAll('[data-lmp-oi="' + i + '"]').forEach(function (s) { s.classList.remove('is-on'); });
      b.classList.add('is-on');
      primary[i] = b.getAttribute('data-lmp-ov');
      var lbl = root.querySelector('[data-lmp-optlabel="' + i + '"]');
      if (lbl) lbl.textContent = titleCase(b.getAttribute('data-lmp-ov'));
      rowState = [];
      syncPrimary();
    });
  });

  root.querySelectorAll('[data-lmp-tab]').forEach(function (tab) {
    var trg = tab.querySelector('[data-lmp-tab-trigger]');
    if (trg) trg.addEventListener('click', function () { tab.classList.toggle('is-open'); });
  });

  function post(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Could not add'); });
      return r.json();
    });
  }

  function doAdd() {
    var items = collectItems();
    if (!items) { updateAddState(); return; }
    if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Adding\u2026'; }
    var done = function () { updateAddState(); };
    if (window.AlasCart && window.AlasCart.addItems) {
      window.AlasCart.addItems(items).then(done).catch(done);
      return;
    }
    post(items).then(function () {
      if (window.AlasCart && window.AlasCart.open) { window.AlasCart.open(); done(); }
      else window.location.href = '/cart';
    }).catch(function () { window.location.href = '/cart'; });
  }

  if (addBtn) addBtn.addEventListener('click', doAdd);

  var sticky = document.querySelector('[data-lmp-sticky]');
  if (sticky) {
    var sBtn = sticky.querySelector('[data-lmp-sticky-add]');
    if (sBtn) sBtn.addEventListener('click', function () {
      if (currentTier().qty > 1 && addBtn) addBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
      else doAdd();
    });
    if (addBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { sticky.classList.toggle('is-visible', !en.isIntersecting); });
      }, { threshold: 0 }).observe(addBtn);
    }
  }

  repriceTiers();
  buildRows();
  updateAddState();
  syncPrimary();
})();
